import React from "react";
import {
  Typography,
  Box,
  Button,
  InputLabel,
  Grid,
  TextField,
} from "@mui/material";

const Step1Component = ({
  trainerData,
  styleClasses,
  grayedOutStyles,
  handleNext,
}) => {
  return (
    <form style={styleClasses.formContainer}>
      <Typography variant="h6" style={styleClasses.sectionTitle}>
        Sections 1 - 2:
      </Typography>
      <Box style={styleClasses.labelContainer}>
        <InputLabel style={styleClasses.labelText}>Type of training carried out in centre</InputLabel>
        <TextField
          variant="outlined"
          value={trainerData?.trainingType.trainingName}
          style={grayedOutStyles}
          fullWidth
          readonly
          size="small"
        />
      </Box>
      <Box style={styleClasses.labelContainer}>
        <InputLabel style={styleClasses.labelText}>Skills taught in centre</InputLabel>
        <TextField
          variant="outlined"
          value={trainerData?.skills.join(" , ")}
          style={grayedOutStyles}
          fullWidth
          readonly
          size="small"
        />
      </Box>
      <Typography variant="h6" style={styleClasses.sectionTitle}>
        Section 3:
      </Typography>
      <Typography variant="subtitle1">
      a. Biodata of Training Centre
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <Box style={styleClasses.labelContainer}>
            <InputLabel style={styleClasses.labelText} htmlFor="type-of-training">Name of Centre</InputLabel>
            <TextField
              id="type-of-training"
              variant="outlined"
              value={trainerData?.skillCenterName}
              style={grayedOutStyles}
              fullWidth
              readonly
              size="small"
            />
          </Box>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Box style={styleClasses.labelContainer}>
            <InputLabel style={styleClasses.labelText} htmlFor="skills-taught">
              Centre Email Address
            </InputLabel>
            <TextField
              id="skills-taught"
              variant="outlined"
              value={trainerData?.centerEmail}
              style={grayedOutStyles}
              fullWidth
              readonly
              size="small"
            />
          </Box>
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <Box style={styleClasses.labelContainer}>
            <InputLabel style={styleClasses.labelText} htmlFor="type-of-training">Phone Number</InputLabel>
            <TextField
              id="type-of-training"
              variant="outlined"
              value={trainerData?.centerPhoneNumber}
              style={grayedOutStyles}
              fullWidth
              readonly
              size="small"
            />
          </Box>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Box style={styleClasses.labelContainer}>
            <InputLabel style={styleClasses.labelText} htmlFor="skills-taught">Whatsapp Number</InputLabel>
            <TextField
              id="skills-taught"
              variant="outlined"
              value={trainerData?.centerWhatsappNumber}
              style={grayedOutStyles}
              fullWidth
              readonly
              size="small"
            />
          </Box>
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <Box style={styleClasses.labelContainer}>
            <InputLabel style={styleClasses.labelText} htmlFor="type-of-training">State</InputLabel>
            <TextField
              id="type-of-training"
              variant="outlined"
              value={trainerData?.state || ""}
              style={grayedOutStyles}
              fullWidth
              readonly
              size="small"
            />
          </Box>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Box style={styleClasses.labelContainer}>
            <InputLabel style={styleClasses.labelText} htmlFor="skills-taught">LGA</InputLabel>
            <TextField
              id="skills-taught"
              variant="outlined"
              value={trainerData?.lga || ""}
              style={grayedOutStyles}
              fullWidth
              readonly
              size="small"
            />
          </Box>
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <Box style={styleClasses.labelContainer}>
            <InputLabel style={styleClasses.labelText} htmlFor="type-of-training">Full Address</InputLabel>
            <TextField
              id="type-of-training"
              variant="outlined"
              value={trainerData?.physicalAddress}
              style={grayedOutStyles}
              fullWidth
              readonly
              size="small"
            />
          </Box>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Box style={styleClasses.labelContainer}>
            <InputLabel style={styleClasses.labelText} htmlFor="skills-taught">Landmark(s)</InputLabel>
            <TextField
              id="skills-taught"
              variant="outlined"
              value={trainerData?.closeLandMark}
              style={grayedOutStyles}
              fullWidth
              readonly
              size="small"
            />
          </Box>
        </Grid>
      </Grid>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginTop: "24px",
        }}
      >
        <Button variant="contained" color="primary" onClick={handleNext}>
          Next
        </Button>
      </div>
    </form>
  );
};

export default Step1Component;
